import React from 'react';
import WidgetSection from '../widget-section/widget-section';
import { WidgetsFactoryInterface, WidgetsListInterface } from './widgets-factory.interfaces';

const TabView: React.FC<{
    items: WidgetsFactoryInterface['children'];
    widgets: WidgetsListInterface;
}> = ({ items, widgets }) => {
    const valid = items.filter(item => widgets[item.type] && item.props?.data !== null);
    const WidgetTabs = widgets.WidgetTabs;
    const WidgetTabsTab = widgets.WidgetTabsTab;
    const WidgetTabsLabel = widgets.WidgetTabsLabel;
    const WidgetTabsContent = widgets.WidgetTabsContent;

    return (
        <WidgetTabs active={0}>
            {
                valid.map((item, key) => (
                    <WidgetTabsTab key={key}>
                        <WidgetTabsLabel>{item.props?.config?.tab?.name}</WidgetTabsLabel>
                        <WidgetTabsContent>
                            { React.createElement(widgets[item.type] as any, item.props as any) }
                        </WidgetTabsContent>
                    </WidgetTabsTab>
                ))
            }
        </WidgetTabs>
    );
};

const RegularView: React.FC<{
    items: WidgetsFactoryInterface['children'];
    widgets: WidgetsListInterface;
}> = ({ items, widgets }) => {
    const valid = items.filter(item => widgets[item.type] && item.props?.data !== null);

    return (
        <>
            {
                valid.map((item, key) => React.createElement(widgets[item.type] as any, { ...item.props, key }))
            }
        </>
    );
};

const WidgetsFactory: React.FC<{
    config: WidgetsFactoryInterface[];
    widgets: WidgetsListInterface;
}> = ({ config, widgets }) => {
    return (
        <>
            {
                config.map((item, idx) => (
                    <WidgetSection key={`${idx}`} title={item.title} link={item.link}
                        styles={item.styles} badge={item.badge} className={item.className}
                    >
                        {item.viewType?.type === 'tab' && <TabView items={item.children} widgets={widgets} />}
                        {item.viewType?.type !== 'tab' && <RegularView items={item.children} widgets={widgets} />}
                    </WidgetSection>
                ))
            }
        </>
    );
};

export default WidgetsFactory;
